/* eslint-disable sonarjs/no-duplicate-string */
import { defineMessages } from "react-intl";
import { useMessages } from "2g-hooks/intl";

const MESSAGES = defineMessages({
  nazevCs: {
    id: "b2b.produkt-editace-form.field.nazevCs.label",
    defaultMessage: "Name CS"
  },
  nazevEn: {
    id: "b2b.produkt-editace-form.field.nazevEn.label",
    defaultMessage: "Name EN"
  },
  popisCs: {
    id: "b2b.produkt-editace-form.field.popisCs.label",
    defaultMessage: "Description CS"
  },
  popisEn: {
    id: "b2b.produkt-editace-form.field.popisEn.label",
    defaultMessage: "Description EN"
  },
  zkratka: {
    id: "b2b.produkt-editace-form.field.zkratka.label",
    defaultMessage: "Abbreviation"
  },
  uzivaNapajeni: {
    id: "b2b.produkt-editace-form.field.uzivaNapajeni.label",
    defaultMessage: "It uses power"
  },
  vylucny: {
    id: "b2b.produkt-editace-form.field.vylucny.label",
    defaultMessage: "Exclusive"
  },
  parkovani: {
    id: "b2b.produkt-editace-form.field.parkovani.label",
    defaultMessage: "Parking"
  },
  bezCasu: {
    id: "b2b.produkt-editace-form.field.bezCasu.label",
    defaultMessage: "Timeless"
  },
  platnostOd: {
    id: "b2b.produkt-editace-form.field.platnostOd.label",
    defaultMessage: "Valid from"
  },
  titleNew: {
    id: "b2b.produkt-editace-widget.titleNew",
    defaultMessage: "New product"
  },
  saveDialogTitle: {
    id: "b2b.produkt-editace-form.save-dialog.title",
    defaultMessage: "Save product"
  },
  deleteDialogTitle: {
    id: "b2b.produkt-editace-form.delete-dialog.title",
    defaultMessage: "Delete product"
  },
  buttonDelete: {
    id: "b2b.produkt-editace-form.button.delete",
    defaultMessage: "Delete"
  },
  buttonSubmit: {
    id: "b2b.produkt-editace-form.button.submit",
    defaultMessage: "Save"
  },
  buttonCancel: {
    id: "b2b.produkt-editace-form.button.cancel",
    defaultMessage: "Cancel"
  }
});

export default () => useMessages(MESSAGES);
